<template>
  <div id="single-avatar-student" :class="{ isNotRounded: rounded }">
    <div
      v-if="picture"
      class="avatar"
      :style="{ backgroundImage: `url(${picture})`, width: size, height: size, borderRadius: size }"
    />
    <div
      v-if="!picture"
      class="no-avatar"
      :style="{ background: disable ? '#D8D8D8' : (imagePrefix() === 'none' ? generateBackgroundColor() : `center/contain no-repeat url(static/img/avatars/hf/${imagePrefix()}${generateNumberFromName(shortName)}.png)`), width: size, height: size, borderRadius: size }"
    >
      <div
        v-if="imagePrefix() === 'none'"
        class="alt"
        :style="{ fontSize: fontSize }"
      >
        {{ alt }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['picture', 'size', 'fontSize', 'firstName', 'shortName', 'rounded', 'boAlt', 'disable', 'gender'],
  data() {
    return {
      alt: null,
      pictureSize: null,
    };
  },
  created() {
    if (this.boAlt) {
      this.alt = this.boAlt;
    }

    if (this.size) {
      this.pictureSize = this.size;
    }

    if (this.firstName) {
      this.generateAlt();
    }

    if (this.shortName) {
      this.generateAltByShortName();
    }
  },
  methods: {
    generateNumberFromName(name) {
      if (!name) {
        return 1;
      }

      const cleanedName = name.toString().replace(/[^a-zA-Z]/g, '');

      // Calculate a hash code based on the ASCII values of the characters in the cleaned name
      let hashCode = 0;
      for (let i = 0; i < cleanedName.length; i += 1) {
        hashCode += cleanedName.charCodeAt(i);
      }

      // Use the hash code to generate a number between 1 and 7
      return (hashCode % 7) + 1;
    },
    imagePrefix() {
      if (this.gender === 'm') {
        return 'M';
      }

      if (this.gender === 'f') {
        return 'F';
      }

      if (this.gender === 'u') {
        return 'N';
      }
      return 'none';
    },
    generateBackgroundColor() {
      const bgColors = ['#F9DCDC', '#CAF0D5', '#FAF1BE', '#D2E0F9', '#F9E2F7', '#F9E9ED', '#FAE3DF', '#E1E8F4', '#E7EED8', '#E7EED8'];
      const randomBg = Math.floor(Math.random() * bgColors.length);
      return bgColors[randomBg];
    },
    generateAlt() {
      const fl = this.firstName.substring(0, 1);
      // const sl = this.lastName.substring(0, 1);
      this.alt = fl;
    },
    generateAltByShortName() {
      const fl = this.shortName.substring(0, 1);
      // const sl = this.shortName.substring(this.shortName.length - 2, this.shortName.length - 1);
      this.alt = fl;
    },
  },
};
</script>
